import { Component } from '@angular/core';

@Component({
    selector: 'fcp-footer-bar',
    template: `
        <div class="fcp-footer-bar">
            <ng-content select="[slot=info]"></ng-content>
            <ng-content select="[slot=actions]"></ng-content>
        </div>
    `,
    styleUrls: ['./fcp-footer-bar.component.less'],
    standalone: false
})
export class FcpFooterBarComponent {}
